import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss'],
})
export class CustomAlertComponent implements OnInit {

  @Input() status : string;
  @Input() title : string;
  @Input() message : string;
  @Input() isClipboard : boolean = false;
  @Input() clipboardValue : string;
  @Input() clipboardDesc : string;

  status_var = {
    success : {
      icon : 'checkmark-circle-outline',
      title : 'Success'
    },
    error : {
      icon : 'alert-circle-outline',
      title : 'Error'
    },
    warning : {
      icon : 'alert-circle-outline',
      title : 'Warning'
    },
    info : {
      icon : 'information-circle-outline',
      title : 'Info'
    }
  }

  constructor(
    private modalCtrl : ModalController
  ) { }

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  copyClipboard(id : string) {
    let clipboardEl : HTMLInputElement = document.getElementById(id) as HTMLInputElement;
    let success_message = document.getElementById(id+'-success-message');
    let default_message = document.getElementById(id+'-default-message');

    navigator.clipboard.writeText(clipboardEl.value);
    success_message.classList.remove('hidden');
    default_message.classList.add('hidden');

    setTimeout(() => {
      success_message.classList.add('hidden');
      default_message.classList.remove('hidden');
    }, 5000);
  }

}
